import { Typography, Box, Stack, Link, SxProps, Theme } from '@mui/material';
import { KeyboardArrowRight } from '@mui/icons-material';
import { motion } from 'framer-motion';

interface CustomCardProps {
    title: string;
    titleIcon: string;
    children: React.ReactNode;
    link?: string;
    handleLinkClick?: () => void;
    boxStyle?: SxProps<Theme>;
}

const CustomCard = ({ title, titleIcon, children, link, handleLinkClick, boxStyle }: CustomCardProps) => {
  return (
    <Box
      sx={boxStyle ?? { py: 3}}
    >
      <Box
        sx={{
          display: "flex",
          mb: 2.5,
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          spacing={1.5}
        >
          <motion.img
            src={titleIcon}
            alt={`${title} Icon`}
            style={{ width: 22, height: 22 }}
            whileHover={{ scale: 1.1, rotate: 5 }}
            transition={{ duration: 0.2 }}
          />
          <Typography
            variant='h4'
            sx={{
              fontWeight: 600,
              color: 'text.primary',
            }}
          >
            {title}
          </Typography>
        </Stack>
        {link &&
          <Stack
            direction="row"
            alignItems="center"
            spacing={0.5}
          >
            <Link
              onClick={handleLinkClick}
              sx={{
                cursor: 'pointer',
                fontSize: '13px',
                fontWeight: 500,
                color: 'text.secondary',
                textDecoration: 'none',
                transition: 'color 0.2s',
                '&:hover': {
                  color: "secondary.main"
                }
              }}
            >
              {link}
            </Link>
            <KeyboardArrowRight
              sx={{
                color: 'text.secondary',
                fontSize: 18,
                transition: 'transform 0.2s',
                '&:hover': {
                  transform: 'translateX(2px)',
                }
              }}
            />
          </Stack>
        }
      </Box>
      <Box>{children}</Box>
    </Box>
  );
}

export default CustomCard;
